export function filterErrorMessages(data: any) {
  try {
    return data.filter((item: any, index: any, arr: any) => {
      // Remove items with isErrorMessage: true and the item before them
      if (item.isErrorMessage) return false; // Exclude error messages
      if (index < arr.length - 1 && arr[index + 1].isErrorMessage) return false; // Exclude the one before the error
      return true; // Keep everything else
    });
  } catch (err: any) {
    return data;
  }
}
